export default __webpack_public_path__ + "static/media/commitment-pro.90e5dc09.png";